import DownIcon from "../../../assets/serviceimgs/downIcon.png";
import LeftIcon from "../../../assets/serviceimgs/rightIcon.png";


export default function useFeed() {
  const data1 = [
    {
      title: "Service URL",
      heading: "Default billing group for securityscorecard-257i",
      icon: DownIcon,
      bgColor: "rgb(244,246,248)",
    },
    {
      title: "Host",
      heading: "Default billing group for securityscorecard-257i",
      icon: DownIcon,
      bgColor: "#fff",
    },
    { title: "port", heading: "23603", icon: DownIcon, bgColor: "rgb(244,246,248)" },
    {
      title: "Access Key",
      heading: "Show",
      icon: DownIcon,
      bgColor: "#fff",
      color: "#824ED2",
      text: "Download",
    },
    {
      title: "Access Certificate",
      heading: "Show",
      icon: DownIcon,
      bgColor: "rgb(244,246,248)",
      color: "#824ED2",
      text: "Download",
    },
    {
      title: "CA Certificate",
      heading: "Show",
      icon: DownIcon,
      bgColor: "#fff",
      color: "#824ED2",
      text: "Download",
    },
  ];

  const data2 = [
    {
      title: "Tags service",
      heading:
        "Tags are name/value pairs that allow you to categorise resources",
      bgColor: "#fff",
      button: "Tag Service",
    },
    {
      switch: {value: true},
      title: "Schema Registry (Karapace)",
      heading:
        "HTTP REST based interface to the Apache Kafka cluster.See the karapace project on Github for documentation.",
      bgColor: "rgb(244,246,248)",
    },
    {
        switch: {value: true},
      title: "Tags service",
      heading:
        "HTTP REST based interface to the Apache Kafka cluster.See the karapace project on Github for documentation.",
        bgColor:'#fff'
    },
    {
      title: "Tags service",
      heading:
        "HTTP REST based interface to the Apache Kafka cluster.See the karapace project on Github for documentation.",
      bgColor: "rgb(244,246,248)",
      switch: {value: true},
    },
    {
      title: "Access Certificate",
      heading:
        "HTTP REST based interface to the Apache Kafka cluster.See the karapace project on Github for documentation.",
      bgColor: "#fff",
      switch: {value: true},
    },
    {
      title: "Apache Kafka version",
      heading: "3.1",
      bgColor: "rgb(244,246,248)",
    },
    {
      title: "Service Plan",
      heading:
        "Startup REST based interface to the Apache Kafka cluster.See the karapace project on Github for documentation.",
      button: "Change Plan",
      bgColor: "#fff",
    },
    {
        title: "Clound and VPC",
        heading:
          "United States, Ohio- Amazon Web Services: Ohio (us-east-2)",
        button: "Migrate Cloud",
        centerButton:'Public Internet',
        bgColor: "rgb(244,246,248)",
        height:'116px'
    },
    {
        title: "Service Inrtegrations",
        heading:
          "No active service integrations",
        button: "Manage integrations",
        leftIcon:LeftIcon,
        bgColor: "#fff",
    },
    {
        title: "Maintenance updates",
        heading:
          "Service is up to date. No maintainance update required",
        button: "Apply Now",
        bgColor: "rgb(244,246,248)",
      
    },
    {
        title: "Maintenance window",
        heading:
          "Sundays after 15:00:10:UTC",
        button: "Change",
        bgColor: "#fff",
      
    },
    {
        title: "Allowed IP Addressess",
        heading:
          "00.00.00/00",
        button: "Change",
        bgColor: "rgb(244,246,248)",
      
    },
    {
        title: "Maintenance window",
        heading:
          "2022-03-31 17:19:09  UTC (1 minute ago)",
          bgColor: "#fff",
      
      
    },
  ];

  return [{ data1, data2 }];
}
